export default __webpack_public_path__ + "static/media/argon-react-white.14615e4c.png";